import PropTypes from "prop-types";
import { Grid, Icon } from "semantic-ui-react";
import { Button } from "hireart-components";

export const PayDetails = ({
  payRate,
  canEditPayRate = false,
  onModalOpen,
  markup = "markup undetermined",
}) => {
  return (
    <Grid.Column>
      <p className="heading"> {payRate}</p>
      <p>pay rate</p>
      <hr />
      <div className="card-spacer">
        {canEditPayRate ? (
          <Button
            className="termination-link is-not-padded"
            size="md"
            basic
            fluid
            onClick={onModalOpen}
          >
            Edit
            <Icon name="chevron right" className="chevron-icon" />
          </Button>
        ) : (
          <>
            <Icon name="line graph" className="chevron-icon" /> {markup}
          </>
        )}
      </div>
    </Grid.Column>
  );
};

PayDetails.propTypes = {
  payRate: PropTypes.string.isRequired,
  canEditPayRate: PropTypes.bool,
  onModalOpen: PropTypes.func.isRequired,
  markup: PropTypes.string,
};
